import { useSelector } from 'react-redux'

/**
 * "Map State to Props" but with useSelector Hook
 * For non-filterInfo variables
 */
export function useStateProps() {
  return useSelector((state) => ({
    stopsFilter: state?.stopsFilter || [],
    airlinesFilter: state?.airlinesFilter || [],
    airportsFilter: state?.airportsFilter || [],
    attributesFilter: state?.attributesFilter || [],
    listingsIsLoading: state?.listingsIsLoading,
    searchRequest: state?.pclnBootstrapData?.searchRequest,
    time: state?.timeFilter || [],
    timebands: state?.filterInfo?.values?.[`timebands${state?.activeTabId}`],
    lastReset: state?.filterInfo?.lastReset,
    latestFilterChange: state?.filterInfo?.latestFilterChange,
    currentMobileFilter: state?.uiToggles?.currentMobileFilter,
    pclnBootstrapData: state?.pclnBootstrapData,
    activeTabId: state?.activeTabId,
  }))
}
